import React from "react";
import { Button } from "antd";
import { Trash2, CircleArrowRight, SquarePen } from "lucide-react";
import { IconButton } from "../buttons";
import { Icon } from "src/components/icons/Icon";

type actionButtonType = "delete" | "open" | "edit";

interface IActionIconProps {
	title: string;
	onClick?: any;
	type: actionButtonType;
	disabled?: boolean;
	size?: "1x" | "lg" | "2x" | number;
}

export const ClearFilterButton = ({ onClick }: { onClick: any }) => (
	<Button className="btn btn-outline-primary" onClick={onClick}>
		Clear
	</Button>
);

export const ActionIcon = ({
	title,
	onClick,
	type,
	disabled,
	size = '1x'
}: IActionIconProps) => {
	if (disabled === undefined) {
		disabled = false;
	}
	if (type === "delete") {
		return (
			<IconButton
				className="pl-0 btn-link"
				title={title}
				onClick={onClick}
				disabled={disabled}
			>
				<Icon size={size} icon={Trash2} />
			</IconButton>
		);
	} else if (type === "open") {
		return (
			<IconButton
				className="btn-link"
				title={title}
				onClick={onClick}
				disabled={disabled}
			>
				<Icon size={size} icon={CircleArrowRight} />
			</IconButton>
		);
	} else if (type === "edit") {
		return (
			<IconButton
				className="btn-link"
				title={title}
				onClick={onClick}
				disabled={disabled}
			>
				<Icon size={size} icon={SquarePen} />
			</IconButton>
		);
	} else {
		return null;
	}
};
